<template>
  <div class="d-flex flex-column align-center wrapper">
    <div class="head"></div>
    <img src="@/assets/doc_avatar.svg" alt="">
    <h1
      class="mt-5"
    >{{$store.state.user.userProfile.firstName + ' ' + $store.state.user.userProfile.lastName}}</h1>
    <v-btn
      outlined
      rounded
      class="mt-4 text-capitalize"
      color="rgb(215,215,215)"
      @click="$router.push('edit-profile')"
    >
      <p class="mb-0 black--text font-weight-regular">Επεξεργασία προφίλ</p>
    </v-btn>
    <v-spacer></v-spacer>
    <div class="bottom d-flex flex-column align-center">
      <p class="mb-0">
        Μέλος από:
        <span class="font-weight-bold">{{date}}</span>
      </p>

      <v-btn rounded text color="red" class="text-capitalize mb-1">
          <a href="mailto:support@dn2me.com?subject=Unsubscribe" class="mb-0" style="text-decoration:none; color:red;">Διαγραφή λογαριασμού</a>
      </v-btn>
    </div>

    <v-snackbar v-model="success" :timeout="3000" color="rgb(0,170,221)">
      Οι αλλαγές αποθηκεύτηκαν επιτυχώς
      <v-icon @click="success=false" color="white">mdi-close</v-icon>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
export default {
  created() {
    console.log(this.$route);
    if (this.$route.params.success) {
      this.success = true;
    }
  },

  data: () => ({
    success: false
  }),

  computed: {
    date() {
      return moment(moment.utc(this.$store.state.user.createdAt).toDate())
        .local()
        .format("DD/MM/YYYY");
    }
  }
};
</script>

<style lang="scss" scoped>

img{
  margin-top: -50px;
}
.wrapper {
  overflow-x: hidden;
  height: 100vh;
}
.head {
  height: 700px;

  width: 120%;
  border-radius: 50%;
  background-color: rgb(0, 170, 221);
  margin-top: -450px;
  border: 10px solid rgb(191, 240, 253);
  justify-self: center;
  @media only screen and (max-width: 600px) {
    height: 400px;
    margin-top: -200px;
    width: 150%;
  }
}
</style>